import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Registrar el Service Worker para proxy de videos
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/videoProxyWorker.js', { scope: '/' })
      .then(registration => {
        console.log('Service Worker para proxy de videos registrado:', registration);
      })
      .catch(error => {
        console.error('Error al registrar el Service Worker para proxy de videos:', error);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
